import * as axios from 'axios'

import { API } from './config'
import { authHeader } from './auth-header'

const getAddressByCep = async (cep) => {
  const requestOptions = {
    headers: authHeader()
  }

  try {
    const response = await axios.get(`${API}/cep/${cep}`, requestOptions)

    return response.data
  } catch (error) {
    console.log(error)

    return null
  }
}

export const cepService = { getAddressByCep }
